<template>
    <div>
        <div>
            <contest-header />
            <div class="full-width">
                <h1
                    class="text-5xl text-center my-5"
                >
                    {{ title }}
                </h1>
                <div v-html="contentWithEmbeds" class="card"/>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
import ContestHeader from '@/js/components/contests/ContestHeader.vue';

export default {
    components: {
        ContestHeader,
    },
    props: {
        title: {
            type: String,
            required: true,
        },

        content: {
            type: String,
            required: true,
        },
    },
    computed: {
        contest() {
            return this.$store.state.contest;
        },
        contentWithEmbeds () {
            let originalContent = this.content;
            const videoId = this.getId(originalContent);
            const iFrameMarkup = `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">
                <iframe src="https://www.youtube.com/embed/${ videoId }"
                        style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
                        frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen>
                </iframe>
            </div>`;
            let result = originalContent.replace(/<figure class="media">.*<\/figure>/g, iFrameMarkup);
            return result;
        }
    },
    methods: {
        getId(url) {
            const regExp = /.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*)".*/;
            const match = url.match(regExp);
            return (match && match[2].length === 11)
                ? match[2]
                : null;
        },
    },
}
</script>
<style lang="scss">
.card a {
    color: #216a94 !important;
}

</style>
